import type React from 'react'

import type { Recipient } from '@/types'
import { clsJoin } from '@/utils'
import { AuthorAvatar } from '../AuthorAvatar'
import css from './styles.module.css'

interface Props {
  active: boolean
  resolved: boolean
  avatars: (Recipient | null)[]
  className: string
}

export const CommentatorsStack: React.FC<Props> = ({
  avatars,
  active,
  resolved,
  className,
}) => {
  const drawOrder = [...avatars].reverse()

  const classes = clsJoin(
    className,
    css.commentators_stack,
    active && css.active,
    resolved && css.resolved
  )

  return (
    <ul className={classes}>
      {drawOrder.map((author) => (
        <li key={author?.id} className={css.comment_avatar}>
          <AuthorAvatar author={author} size="sm" />
        </li>
      ))}
    </ul>
  )
}
